import React from "react";
import { AddressValidationRules } from "../../../../AutocompleteAddressHeadless/constants/AddressValidationRules";
import { AutocompleteAddressHeadless } from "../../../../AutocompleteAddressHeadless/AutocompleteAddressHeadless";
import { Box, TextField } from "@material-ui/core";
import { useFormContext } from "react-hook-form";

export const AddressComplementForm = () => {
  const formMethods = useFormContext();
  return (
    <Box>
      <AutocompleteAddressHeadless.FloorNumber
        as={<TextField type="number" />}
        formMethods={formMethods}
        forceEnable
        rules={AddressValidationRules.maxLengthValidation(false, 2)}
      />
      <AutocompleteAddressHeadless.DoorNumber
        as={<TextField />}
        formMethods={formMethods}
        forceEnable
        rules={AddressValidationRules.maxLengthValidation(false, 1)}
      />
      <AutocompleteAddressHeadless.Building
        as={<TextField />}
        formMethods={formMethods}
        forceEnable
        rules={AddressValidationRules.maxLengthValidation(false, 5)}
      />
    </Box>
  );
};
